<template>
    <div class="foot">
        <div class="content">
            <div class="hichinese-copyright-text">&copy; 2018-2020 bestmali.cn 版权所有 ICP证：<a href="http://beian.miit.gov.cn/" target="_blank">浙ICP备19012618号-1</a></div>
        </div>
    </div>
</template>
<script>
export default {
    name:'Footer',
    data(){
        return{
            isMobile:false
        }
    },
    created(){
        var sUserAgent = navigator.userAgent.toLowerCase();
        var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
        var bIsMidp = sUserAgent.match(/midp/i) == "midp";
        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
        var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
        var bIsAndroid = sUserAgent.match(/android/i) == "android";
        var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
        var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    
        if (!(bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM)) {
            // alert("当前是电脑打开") 
            this.isMobile = false
        }else{
            // alert("当前是手机打开")
            this.isMobile = true
        }

    },
    methods:{
        toJudge(){
            if(!this.$store.state.hasLogin){
                this.toast('请登录后再试')
                return
            }
            let verified = this.$store.state.userData.verified
            setTimeout(()=>{
                if(verified == 0){
                    this.openWindow('Auditing')
                }else{
                    this.toast('您已经是我们的老师了')
                }
            },400)
        },
        openToMobile(){
            window.location.href = "https://h5.hichinese.xyz/#/"
        }
    }
}
</script>
<style scoped>
.foot{
    position: absolute;
    width:100%;
    line-height: 40px;
    bottom: 0;
    background: #363A45;
}
.content{
    font-size: 10px;
    color:#fff;
}

.mobile-btn{
    position:absolute;
    top:20px;
    right:20px;
    font-size:45px;
    font-weight: bolder;
    font-style: italic;
}
</style>